import React, { useEffect } from 'react'
import Loader from 'view/component/loader'
import * as Components from './lazy-components'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useAuthenticator } from '@aws-amplify/ui-react'
import { useNavigate } from 'react-router-dom'
import { useAuth0 } from "@auth0/auth0-react";
import { useLocation } from 'react-router'
import { Credentials } from '@aws-amplify/core';


const Routes = (isAuthed) => {
  const { isAuthenticated, isLoading } = useAuth0();
  const location = useLocation()
  
  
  const navigate = useNavigate()
  useEffect(() => {
    if (isAuthenticated && (location.pathname === '/login' || location.pathname === '/')) {
      navigate('/dashboard')
    }
  }, [isAuthenticated])

  return (
        <>
            {isLoading && <Loader />}
            {!isAuthenticated ? <Components.Login /> : <Components.LoggedInRoutes />}
        </>
  )
}

Routes.propTypes = {
  isAuthenticated: PropTypes.bool
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated
})

export default connect(mapStateToProps)(Routes)
